<div class="main-body" [ngStyle]="{ 'background-color': colorSelectable.color }">
  @if (colorSelectable.isSelected) {
    <div class="done-mark">
      <span nz-icon style="font-size: 25px" class="material-symbols-rounded">check</span>
    </div>
  }
</div>
